import React, { useState, useEffect, useRef } from "react";
import jsep from "jsep";
import NumericQuestion from "../Questions/NumericQuestion";
import MultiselectDropdown from "../Questions/MultiSelectionDropDown/MultiSelectionDropdown";
import ImagePicker from "../Questions/ImageSelection/Imageselection";
import DateQuestion from "../Questions/DateSelection/DateSelection";
import SliderScaleQuestion from "../Questions/SliderScale/SliderScale";
import NPSQuestion from "../Questions/NPS/NPSSelection";
import StarRatingQuestion from "../Questions/Stars/StarQuestion";
import SelectListQuestion from "../Questions/SelectList/SelectList";
import BooleanQuestion from "../Questions/Boolean/BooleanQuestion";
import RadioQuestion from "../Questions/Radio/RadioQuestion";
import MultiChoiceQuestion from "../Questions/MultiChoice/MultiChoiceQuestion";
import RatingQuestion from "../Questions/Rating/RatingQuestion";
import MatrixQuestion from "../Questions/SingleMatrix/SingleMatrixQuestion";
import MatrixMultiChoiceQuestion from "../Questions/MultiMatrix/MultiMatrixQuestion";
import SingleDropdownQuestion from "../Questions/SingleDropDown/SingleDropDown";
import HeadingQuestion from "../Questions/Heading/HeadingQuestion";
import OpenTextQuestion from "../Questions/OpenText/OpenText";
import RankingQuestionDND from "../Questions/RankingDND/DragAndDropQuestion";
import Footer from "../../Footer/Footer";
import SelectListQuestionWithArr from "../Questions/SelectList/NewSelectList";
import { API_END_POINT } from "../../config";
import MultiTextQuestion from "../Questions/MultiText/MultiText";
import { checkForTermination } from "../../Utils/TerminationCheck.utils";
import "./Questionnaire.css";
import MatrixMultiOptionQuestionCard from "../Questions/MultiMatrixOption/MultiMatrixOptionQuestion";

const Questionnaire = ({
  pages,
  Latitude,
  Longitude,
  wholeWord,
  hasTranslations,
}) => {
  //console.log(pages, "pages");

  const [formValues, setFormValues] = useState({});
  const [selectedCell, setSelectedCell] = useState({});
  const [pageIndex, setPageIndex] = useState(0);
  const [showError, setShowError] = useState(false);
  const [isAnswerValid, setIsAnswerValid] = useState(true);
  const [responseID, setResponseID] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [submissionCounts, setSubmissionCounts] = useState({});
  const [visitedPages, setVisitedPages] = useState(new Set());
  const currentPage = pages.pages[pageIndex];
   const choiceOrderRef = useRef({});
    const getChoiceOrder = (questionKey) => {
    return choiceOrderRef.current[questionKey];
    };

    const setChoiceOrder = (questionKey, order) => {
      choiceOrderRef.current[questionKey] = order;
    };
  useEffect(() => {
    setVisitedPages((prev) => new Set(prev).add(pageIndex));
    if (!submissionCounts[pageIndex]) {
      setSubmissionCounts((prev) => ({ ...prev, [pageIndex]: 1 }));
    }
  }, [pageIndex]);
  const getText = (item, field) => {
    const translatedField = `${field}Trans`;
    return hasTranslations && item[translatedField]
      ? item[translatedField]
      : item[field];
  };
  // const getChoiceAnswerString = (question, selectedValues = []) => {
  //   return question.choices
  //     .map((choice) => {
  //       if (choice.optionType === "OTHER") {
  //         const match = selectedValues.find((val) =>
  //           val.startsWith(`Other:${choice.tempId}:`)
  //         );
  //         if (match) {
  //           const parts = match.split(":");
  //           return parts.length >= 3 ? `Other ${parts.slice(2).join(":")}` : "";
  //         }
  //         return "";
  //       } else {
  //         return selectedValues.includes(choice.value) ? choice.value : "";
  //       }
  //     })
  //     .join(", ");
  // };
  const handleChange = (e) => {
    const { name, value, type, checked, otherText } = e.target;

    const normalizedTempId = name;
    const currentQuestion = currentPage.elements.find(
      (q) => q.tempId === normalizedTempId
    );
    switch (type) {
      case "checkbox":
        setFormValues((prev) => {
          const newValue = { ...prev, [name]: value };

          // Check for termination after state update
          setTimeout(() => {
            if (
              currentQuestion &&
              checkForTermination(currentQuestion, [value])
            ) {
              setIsComplete(true);
            }
          }, 1000);

          return newValue;
        });
        break;
      case "radio":
        setFormValues((prev) => {
          const newValue = { ...prev, [normalizedTempId]: [value] };

          // Check for termination after state update
          setTimeout(() => {
            if (
              currentQuestion &&
              checkForTermination(currentQuestion, value)
            ) {
              setIsComplete(true);
            }
          }, 0);

          return newValue;
        });
        break;

      case "matrix":
        if (normalizedTempId.includes("_")) {
          const [row, col] = normalizedTempId.split("_").slice(1);
          setSelectedCell({ row: parseInt(row), col: parseInt(col) });
          setFormValues((prevState) => ({
            ...prevState,
            [`${normalizedTempId.split("_")[0]}_${row}`]: value, // Use row as the key
          }));
        }
        break;
      case "matrixmultiChoice":
        if (normalizedTempId.includes("_")) {
          const [row, col] = normalizedTempId.split("_").slice(1);
          setSelectedCell({ row: parseInt(row), col: parseInt(col) });
          setFormValues((prevState) => ({
            ...prevState,
            [`${normalizedTempId}_row${row}`]: [
              ...(prevState[`${normalizedTempId}_row${row}`] || []),
              value,
            ],
          }));
        }
        break;
 case "matrixOptionChoice":
      if (normalizedTempId.includes("_")) {
        const [tempId, row, col] = normalizedTempId.split("_");
        setFormValues(prev => {
          const currentAnswers = prev[tempId] || [];
          const rowKey = `${tempId}_r${parseInt(row) + 1}`;
          const rowAnswer = currentAnswers.find(a => a[rowKey]) || { [rowKey]: [] };
          const updatedRowValues = [...rowAnswer[rowKey]];
          updatedRowValues[parseInt(col)] = value;

          return {
            ...prev,
            [tempId]: [
              ...currentAnswers.filter(a => !a[rowKey]),
              { [rowKey]: updatedRowValues }
            ]
          };
        });
      }
      break;
      default:
        setFormValues((prevState) => ({
          ...prevState,
          [normalizedTempId]: value,
        }));
        break;
    }
  };

  const handleSwitchChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleDropDownChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // do something with the form values
  };

  const evaluateExpression = (expression) => {
    try {
      expression = expression
        .replaceAll(/\band\b/g, "&&")
        .replaceAll(/\bor\b/g, "||")
        .replaceAll(/([^><=!])=([^=])/g, "$1==$2");

      const replacedExpression = expression.replace(
        /{(.*?)}/g,
        (match, p1, p2) => {
          const value = formValues[p1.trim()];
          // console.log(match, p2, "match")
          if (value === undefined) {
            return `'${p1.trim()}'`; // Wrap undefined values in quotes
          } else if (Array.isArray(value)) {
            const containsAnyElement = value.some((element) =>
              new RegExp(`\\b${element}\\b`).test(expression)
            );
            return containsAnyElement;
          } else if (!isNaN(value)) {
            return parseInt(value);
          } else {
            return value; // Wrap other values in quotes
          }
        }
      );

      //console.log(replacedExpression, "replacedExpression");

      const leftSide = replacedExpression.split(" ")[0].replace("(", "");

      if (leftSide.startsWith("true")) {
        return true;
      }

      const ast = jsep(replacedExpression);
      const variables = ast.variables ? Object.keys(ast.variables) : [];
      const values = variables.map((variable) => formValues[variable]);

      const fn = new Function(...variables, `return ${replacedExpression};`);
      const result = fn(...values);
      //console.log(`Expression "${expression}" evaluated to ${result}`);
      return result;
    } catch (error) {
      console.error(error, "error");
      return false;
    }
  };

  const handleNPSChange = (e) => {
    const { name, value } = e.target;
    const updatedValues = {
      ...formValues,
      [name]: value,
    };
    setFormValues(updatedValues);
  };

  const handleStarChange = (event) => {
    const { name, value } = event.target;
    const updatedValues = {
      ...formValues,
      [name]: value,
    };
    setFormValues(updatedValues);
  };

  // const validateAnswer = (question) => {
  //   const answer = formValues[question.tempId];
  //   return answer && answer.trim().length > 0;
  // };
  const processChoices = (choices) => {
    if (!choices) return choices;

    // Case 1: Choices is already in object format - just apply translations
    if (typeof choices[0] === "object" && choices[0] !== null) {
      return choices.map((choice) => ({
        ...choice,
        text: getText(choice, "text"),
        // Only add value if it doesn't exist
        ...(choice.value === undefined && { value: getText(choice, "text") }),
      }));
    }

    // Case 2: Choices is in string format - leave as is (no conversion to objects)
    return choices;
  };
  const renderQuestion = (question) => {
    const translatedQuestion = {
      ...question,
      questionText: getText(question, "questionText"),
      questionDescription: getText(question, "questionDescription"),
      requiredErrorText: getText(question, "requiredErrorText"),
      placeHolderText: getText(question, "placeHolderText"),
      choices: processChoices(question.choices),
    };
    let inputElement;

    switch (question.type) {
      case "heading":
        inputElement = <HeadingQuestion questionText={translatedQuestion} />;
        break;

      case "numeric":
        inputElement = (
          <NumericQuestion
            question={translatedQuestion}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;
      case "ranking":
        inputElement = (
          <RankingQuestionDND
            question={translatedQuestion}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;

      case "openText":
        inputElement = (
          <OpenTextQuestion
            question={translatedQuestion}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;
      case "multiText": {
  let multiTextInputs = [];

  // 1️⃣ Base choices (always present)
  const baseChoices = translatedQuestion.choices || [];

  let pipelineChoices = [];

  // 2️⃣ Pipeline logic
  if (
    translatedQuestion.option_pipeline &&
    translatedQuestion.option_pipeline_type
  ) {
    const referencedQuestion = pages.pages
      .flatMap(page => page.elements)
      .find(
        q => q.id?.toString() === translatedQuestion.option_pipeline?.toString()
      );

    if (referencedQuestion?.choices) {
      const selectedValues =
        formValues[referencedQuestion.tempId] || [];

      const selectedSet = new Set(
        selectedValues.map(v => v.toString())
      );

      const filteredChoices = referencedQuestion.choices.filter(choice => {
        const value = choice.value?.toString();

        if (translatedQuestion.option_pipeline_type === "include") {
          return selectedSet.has(value);
        }

        if (translatedQuestion.option_pipeline_type === "exclude") {
          return !selectedSet.has(value);
        }

        return false;
      });

      pipelineChoices = filteredChoices.map(choice => ({
        value: choice.value?.toString(),
        text: choice.text || choice.value,
        tempId: choice.tempId,
        source: "pipeline"
      }));
    }
  }

  // 3️⃣ Merge base + pipeline choices (no duplicates)
  const mergedChoicesMap = new Map();

  [...baseChoices, ...pipelineChoices].forEach(choice => {
    const key = choice.value?.toString();
    if (key && !mergedChoicesMap.has(key)) {
      mergedChoicesMap.set(key, {
        ...choice,
        value: key,
        text: choice.text || choice.value,
        source: choice.source || "base"
      });
    }
  });

  multiTextInputs = Array.from(mergedChoicesMap.values());

  inputElement = (
    <MultiTextQuestion
      question={{
        ...translatedQuestion,
        choices: multiTextInputs
      }}
      handleChange={handleChange}
      formValues={formValues}
      showError={showError}
    />
  );
  break;
}


      case "radiogroup":
        inputElement = (
          <RadioQuestion
            question={translatedQuestion}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
             getChoiceOrder={getChoiceOrder}
            setChoiceOrder={setChoiceOrder}
          />
        );
        break;
      case "checkbox":
        let pipelineChoices = translatedQuestion.choices;

        if (
          translatedQuestion.option_pipeline &&
          translatedQuestion.option_pipeline !== "" &&
          translatedQuestion.option_pipeline !== null
        ) {
          const referencedQuestion = pages.pages
            .flatMap((page) => page.elements)
            .find(
              (q) =>
                q.id?.toString() ==
                translatedQuestion.option_pipeline?.toString()
            );

          if (referencedQuestion && referencedQuestion.choices) {
            const referencedSelected =
              formValues[referencedQuestion.tempId] || [];

            let filteredChoices = [];

            if (translatedQuestion.option_pipeline_type === "include") {
              filteredChoices = referencedQuestion.choices.filter((choice) => {
                if (choice.optionType === "OTHER") {
                  // include only if this specific tempId has a selected "Other"
                  return referencedSelected.some((val) => {
                    const parts = val.split(":");
                    return parts[0] === "Other" && parts[1] == choice.tempId;
                  });
                }
                return referencedSelected.includes(choice.value);
              });
            } else if (translatedQuestion.option_pipeline_type === "exclude") {
              filteredChoices = referencedQuestion.choices.filter((choice) => {
                if (choice.optionType === "OTHER") {
                  // exclude only if this specific tempId has a selected "Other"
                  return !referencedSelected.some((val) => {
                    const parts = val.split(":");
                    return parts[0] === "Other" && parts[1] == choice.tempId;
                  });
                }
                return !referencedSelected.includes(choice.value);
              });
            }

            // Treat piped-in OTHER as normal choices (remove optionType: "OTHER")
            filteredChoices = filteredChoices
              .map((choice) => {
                if (choice.optionType === "OTHER") {
                  const selectedOther = referencedSelected.find((val) => {
                    const parts = val.split(":");
                    return parts[0] === "Other" && parts[1] == choice.tempId;
                  });
                  if (selectedOther) {
                    const parts = selectedOther.split(":");
                    const otherInput = parts.slice(2).join(":") || "";
                    return {
                      ...choice,
                      text: otherInput ? `${otherInput}` : "Other",
                      value: selectedOther, // full value "Other:13:test"
                      optionType: undefined, // <-- treat as normal
                    };
                  }
                  return null; // drop unselected OTHER
                }
                return choice;
              })
              .filter(Boolean);

            // --- handle merging ---
            const allValues = new Set(
              translatedQuestion.choices.map((c) => c.value)
            );
            let mergedChoices = [
              ...translatedQuestion.choices,
              ...filteredChoices.filter((c) => !allValues.has(c.value)),
            ];

            // --- move None & Other at the end ---
            const normalChoices = mergedChoices.filter(
              (c) => c.optionType !== "NONE" && c.optionType !== "OTHER"
            );
            const specialChoices = mergedChoices.filter(
              (c) => c.optionType === "NONE" || c.optionType === "OTHER"
            );

            pipelineChoices = [...normalChoices, ...specialChoices];
          }
        }
        inputElement = (
          <MultiChoiceQuestion
            question={{ ...translatedQuestion, choices: pipelineChoices }}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;
      case "rating":
        inputElement = (
          <RatingQuestion
            question={translatedQuestion}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;
      case "matrix":
        inputElement = (
          <MatrixQuestion
            question={translatedQuestion}
            formValues={formValues}
            handleChange={handleChange}
            showError={showError}
             getChoiceOrder={getChoiceOrder}
              setChoiceOrder={setChoiceOrder}
          />
        );
        break;

      case "matrixmultiChoice":
        inputElement = (
          <MatrixMultiChoiceQuestion
            question={translatedQuestion}
            formValues={formValues}
            setFormValues={setFormValues}
            showError={showError}
          />
        );
        break;
         case "matrixOptionChoice":
                inputElement = (
                    <MatrixMultiOptionQuestionCard
                        question={translatedQuestion}
                        formValues={formValues}
                        setFormValues={setFormValues}
                        showError={showError} />
                );
                break;
      case "singleDropdown":
        inputElement = (
          <SingleDropdownQuestion
            question={translatedQuestion}
            formValues={formValues}
            handleChange={handleChange}
            showError={showError}
          />
        );
        break;

      case "imagepicker":
        inputElement = (
          <ImagePicker
            key={translatedQuestion.tempId}
            question={translatedQuestion}
            formValues={formValues}
            handleChange={handleDropDownChange}
            showError={showError}
          />
        );
        break;

      case "date":
        inputElement = (
          <DateQuestion
            question={translatedQuestion}
            handleChange={handleDropDownChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;

      case "sliderScale":
        inputElement = (
          <SliderScaleQuestion
            question={translatedQuestion}
            handleChange={handleDropDownChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;

      case "NPS":
        inputElement = (
          <NPSQuestion
            question={translatedQuestion}
            handleChange={handleNPSChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;
      case "starRating":
        inputElement = (
          <StarRatingQuestion
            question={translatedQuestion}
            handleChange={handleStarChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;

      case "selectList":
        inputElement = (
          <SelectListQuestionWithArr
            question={translatedQuestion}
            handleChange={handleChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;

      case "multiselectdropdown":
        inputElement = (
          <MultiselectDropdown
            key={translatedQuestion.tempId}
            question={translatedQuestion}
            formValues={formValues}
            showError={showError}
            setFormValues={setFormValues}
            handleChange={handleDropDownChange}
          />
        );
        break;

      case "boolean":
        inputElement = (
          <BooleanQuestion
            key={translatedQuestion.tempId}
            question={translatedQuestion}
            handleChange={handleSwitchChange}
            formValues={formValues}
            showError={showError}
          />
        );
        break;

      default:
        inputElement = null;
    }

    const visible =
      !translatedQuestion.visibleIf ||
      evaluateExpression(translatedQuestion.visibleIf);

    return (
      <div
        className="container-fluid h-100 responsive-padding"
        key={translatedQuestion.tempId}
        style={{ display: visible ? "block" : "none" }}
      >
        {/* <label>{question.questionText}</label> */}
        {inputElement}
      </div>
    );
  };
  // Recursive function to flatten nested arrays
  // function flattenNestedArrays(arr) {
  //   return arr.reduce((result, item) => {
  //     if (Array.isArray(item)) {
  //       result.push(...flattenNestedArrays(item));
  //     } else {
  //       result.push(item);
  //     }
  //     return result;
  //   }, []);
  // }

  const renderPage = (page, pageIndex) => {
    const translatedPage = {
      ...page,
      elements: page.elements.map((element) => ({
        ...element,
        questionText: getText(element, "questionText"),
        questionDescription: getText(element, "questionDescription"),
        choices:
          element.choices?.map((choice) => ({
            ...choice,
            text: getText(choice, "text"),
            value: choice.value,
          })) || element.choices,
      })),
    };

    const isLastPage = pageIndex === pages.pages.length - 1;

    const submitSurveyResponse = async (pageIdx) => {
      const now = new Date();
      const responseDate = now.toISOString().split("T")[0];
      const surveyLocation = `${Latitude},${Longitude}`;
      const currentCount = submissionCounts[pageIdx] || 1;

      const questions = pages.pages[pageIdx].elements
        .filter((element) => {
          //console.log("element",element)
          // Include if has values or is matrix/multi-matrix with responses
            return (
      formValues[element.tempId] !== undefined ||
      (
        (element.type === 'matrix' ||
         element.type === 'matrixmultiChoice' ||
         element.type === 'matrixOptionChoice') &&
        formValues[element.tempId]?.length > 0
      )
    );
        })
        .map((element) => {
          // Handle non-matrix questions
          if (element.type === "multiText") {
            //"country: 1; state: ; city: 3"

            //const answers = formValues[element.tempId] || {};
            // return {
            //     id: element.id,
            //     code: element.tempId,
            //     answerText: Object.entries(answers)
            //         .map(([key, value]) => `${key}: ${value ?? ''}`)  // Keep empty string if any
            //         .join("; "),
            // };
            const answers = formValues[element.tempId] || {};
            const keys =
              element.multiTextElements?.map((el) => el.name) ||
              Object.keys(answers); // ordered keys if available
            const orderedValues = keys.map((key) => answers[key] || "");

            return {
              id: element.id,
              code: element.tempId,
              answerText: orderedValues.join(","),
            };
          }
          // ...existing code...
          // ...inside submitSurveyResponse map...
          if (element.type === "checkbox") {
            const selected = formValues[element.tempId] || [];

            if (
              element.option_pipeline &&
              element.option_pipeline !== "" &&
              element.option_pipeline !== null
            ) {
              const referencedQuestion = pages.pages
                .flatMap((page) => page.elements)
                .find(
                  (q) =>
                    q.id?.toString() === element.option_pipeline?.toString()
                );

              // Separate main and piped choices
              const mainChoices = (element.choices || []).filter(
                (c) => c.optionType !== "OTHER"
              );
              const mainOthers = (element.choices || []).filter(
                (c) => c.optionType === "OTHER"
              );

              let pipedChoices = [];
              let pipedOthers = [];
              if (referencedQuestion && referencedQuestion.choices) {
                pipedChoices = referencedQuestion.choices.filter(
                  (c) =>
                    c.optionType !== "OTHER" &&
                    !mainChoices.some((mc) => mc.value === c.value)
                );
                pipedOthers = referencedQuestion.choices.filter(
                  (c) => c.optionType === "OTHER"
                );
              }

              // 1. Main normal options
              const mainNormalArr = mainChoices.map((choice) =>
                selected.includes(choice.value) ? choice.value : ""
              );

              // 2. Piped normal options
              const pipedNormalArr = pipedChoices.map((choice) =>
                selected.includes(choice.value) ? choice.value : ""
              );

              // 3. Piped "Other" options (format: other:text)
              const pipedOtherArr = pipedOthers.map((choice) => {
                // Find selected value for this piped other
                const match = selected.find((val) =>
                  val.startsWith(`Other:${choice.tempId}:`)
                );
                if (match) {
                  const parts = match.split(":");
                  return parts.length >= 3
                    ? `other:${parts.slice(2).join(":")}`
                    : "";
                }
                return "";
              });

              // 4. Main "Other" options (format: other:text)
              const mainOtherArr = mainOthers.map((choice) => {
                const match = selected.find((val) =>
                  val.startsWith(`Other:${choice.tempId}:`)
                );
                if (match) {
                  const parts = match.split(":");
                  return parts.length >= 3
                    ? `other:${parts.slice(2).join(":")}`
                    : "";
                }
                return "";
              });

              // Final answer array in required order
              const answerArr = [
                ...mainNormalArr,
                ...pipedNormalArr,
                ...pipedOtherArr,
                ...mainOtherArr,
              ];

              return {
                id: element.id,
                code: element.tempId,
                answerText: answerArr.join(","),
              };
            } else {
              // Non-piped (normal checkbox)
              const mainChoices = (element.choices || []).filter(
                (c) => c.optionType !== "OTHER"
              );
              const mainOthers = (element.choices || []).filter(
                (c) => c.optionType === "OTHER"
              );

              const mainNormalArr = mainChoices.map((choice) =>
                selected.includes(choice.value) ? choice.value : ""
              );
              const mainOtherArr = mainOthers.map((choice) => {
                const match = selected.find((val) =>
                  val.startsWith(`Other:${choice.tempId}:`)
                );
                if (match) {
                  const parts = match.split(":");
                  return parts.length >= 3
                    ? `other:${parts.slice(2).join(":")}`
                    : "";
                }
                return "";
              });

              const answerArr = [...mainNormalArr, ...mainOtherArr];

              return {
                id: element.id,
                code: element.tempId,
                answerText: answerArr.join(","),
              };
            }
          }

          // ...existing code...
          // ...existing code...
          if (element.type === "multiselectdropdown") {
            const selected = formValues[element.tempId] || [];

            // Assuming element.choices is the full option list like [{value: "1"}, {value: "2"}...]
            const orderedAnswer = (element.choices || []).map((choice) => {
              return selected.includes(choice.value) ? choice.value : "";
            });

            return {
              id: element.id,
              code: element.tempId,
              answerText: orderedAnswer.join(","),
            };
          }

          if (
            element.type !== "matrix" &&
            element.type !== "matrixmultiChoice" &&
             element.type !== "matrixOptionChoice"
          ) {
            return {
              id: element.id,
              code: element.tempId,
              answerText: Array.isArray(formValues[element.tempId])
                ? formValues[element.tempId].join(", ")
                : formValues[element.tempId]?.toString() || "",
            };
          }

          // Handle matrix questions
          const isMultiChoice = element.type === "matrixmultiChoice";
          const isMultiOption = element.type === "matrixOptionChoice";
            //console.log(element.type , "element.type")
          const matrixResponses = element.rows.map((row, rowIndex) => {
            let selectedValues = [];
          
            // Get the response for this row

        if (isMultiChoice) {
    const rowKey = `${element.tempId}_r${rowIndex + 1}`;
    selectedValues = formValues[element.tempId]?.[rowIndex]?.[rowKey] || [];
  } else if (isMultiOption) {
    //console.log(element , formValues , "type" )
 const rowKey = `${element.tempId}_r${rowIndex + 1}`;
    const rowObj = formValues[element.tempId]?.find(a => a[rowKey]) || {};
    selectedValues = rowObj[rowKey] || [];
  } else {
    const rowKey =
      Object.keys(formValues[element.tempId]?.[rowIndex] || {})[0] || "";
    const value = formValues[element.tempId]?.[rowIndex]?.[rowKey];
    if (value) selectedValues = [value];
  }


            // Build columns object
            let columns = {};
  element.columns.forEach((col) => {
    if (isMultiChoice ) {
      // 1 if selected, 0 otherwise
      columns[col] = selectedValues.includes(col) ? 1 : 0;
    } else if (isMultiOption) {
      // For multiple selections stored as array
       columns = {
      value: Array.isArray(selectedValues)
        ? selectedValues.join(",")
        : selectedValues?.toString() || "",
    };
    }
    
    
    else {
      // For single choice: 1 for selected, 0 for others
      columns[col] = selectedValues[0] === col ? 1 : 0;
    }
  });
            return {
              row: row,
              columns: columns,
            };
          });

          return {
            id: element.id,
            code: element.tempId,
            response: matrixResponses,
            //submissionCounts: currentCount,
          };
        });

      const surveyResponse = {
        responseid: pageIdx === 0 ? 0 : responseID,
        responsedate: responseDate,
        respondentcode: pages?.surveycode,
        surveylocation: surveyLocation,
        answer: {
          surveyid: pages?.surveyid || "",
          surveycode: pages?.surveycode || "",
          surveyname: pages?.surveyname || "",
          surveyheading: pages?.surveyname,
          questions: questions,
          submissionCounts: currentCount,
        },
      };
      //  console.log(surveyResponse, "surveyResponse");

      setSubmissionCounts((prev) => ({
        ...prev,
        [pageIdx]: visitedPages.has(pageIdx) ? (prev[pageIdx] || 1) + 1 : 1,
      }));

      try {
        const response = await fetch(
          `${API_END_POINT.BASE_URL}/api/Response/PostResponse`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(surveyResponse),
          }
        );
        const data = await response.json();
        setResponseID(data?.data?.Status);
        setSubmissionCounts((prev) => ({
          ...prev,
          [pageIdx]: (prev[pageIdx] || 1) + 1,
        }));
        // return data;
      } catch (error) {
        console.error("Error submitting survey:", error);
        throw error;
      }
    };

    const onNextClick = async (e) => {
      e.preventDefault();
 const currentPageElements = pages.pages[pageIndex].elements;
     const isValid = currentPageElements?.every((element) => {
        const value = formValues[element.tempId];
        const isVisible = !element.visibleIf || evaluateExpression(element.visibleIf);
        

        if (!isVisible) return true;               // skip invisible
        if (!element.isMandatory) return true;     // skip non-mandatory

        // --- special case for multiText ---
        if (element.type?.toLowerCase() === "multitext") {
            if (!value || typeof value !== "object") return false;
            return element.choices?.every(choice => {
                const v = value[choice.value];
                return typeof v === "string" && v.trim() !== "";
            });
        }

        // --- normal mandatory check ---
        if (typeof value === "string") {
            return value.trim() !== "";
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !!value;
    });
    if (!isValid || !isAnswerValid) {
        setShowError(true);
        return;
    }
    setShowError(false);
      

      // Submit current page data
      // if (pageIndex === 0) {
      //     await submitSurveyResponse(pageIndex);
      // } else {
      //     submitSurveyResponse(pageIndex); // Fire and forget for subsequent pages
      // }
      await submitSurveyResponse(pageIndex);
      // Find next visible page
      for (let i = pageIndex + 1; i < pages.pages.length; i++) {
        const hasVisibleElement = pages.pages[i].elements.some(
          (element) =>
            !element.visibleIf || evaluateExpression(element.visibleIf)
        );

        if (hasVisibleElement) {
          setPageIndex(i);
          return;
        }
      }

      // No visible questions found, proceed to next page or complete
      if (pageIndex === pages.pages.length - 1) {
        setIsComplete(true);
      } else {
        setPageIndex(pageIndex + 1);
      }
    };
    const onBackClick = (e) => {
      e.preventDefault();
      const currentFormValues = { ...formValues };
      // Find previous visible page
      for (let i = pageIndex - 1; i >= 0; i--) {
        const hasVisibleElement = pages.pages[i].elements.some(
          (element) =>
            !element.visibleIf || evaluateExpression(element.visibleIf)
        );

        if (hasVisibleElement) {
          setPageIndex(i);
          setFormValues(currentFormValues);
          return;
        }
      }

      // If no previous visible page found, go to first page
      if (pageIndex > 0) {
        setPageIndex(0);
        setFormValues(currentFormValues);
      }
    };
    const onCompleteClick = async (e) => {
      e.preventDefault();

      await submitSurveyResponse(pageIndex);
      setIsComplete(true);
    };

    const titleStyle = {
      textAlign: pages.header.titlePosition,
    };

    const logoStyle = {
      float: pages.header.logoPosition,
      marginRight: pages.header.logoPosition === "right" ? "0px" : "10px",
      marginLeft: pages.header.logoPosition === "left" ? "0px" : "10px",
    };

    return (
      <div style={{ position: "relative", paddingBottom: "10px" }}>
  <div
    style={{
      ...pages.header.surveyheadingBackground,
      display: "flex",
      alignItems: "center", // ✅ centers logo vertically with title+desc
      justifyContent: "space-between",
      padding: "10px 20px",
    }}
  >
    {/* Left side: title + description stacked */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: pages.header.titlePosition || "center",
        justifyContent: "center",
        flex: 1,
        color: pages.header.surveyheadingForeground?.color || "#fff",
      }}
    >
      <p
        style={{
          ...pages.header.surveyheadingForeground,
          ...titleStyle,
          margin: 0,
          fontSize: "28px",
        }}
      >
        {pages.header.title}
      </p>
      <p
        style={{
          ...pages.header.surveyheadingForeground,
          margin: 0,
          fontSize: "20px",
        }}
      >
        {pages.header.description}
      </p>
    </div>

    {/* Right side: logo vertically centered */}
    <img
      src={pages.header.logo}
      style={{
        height: "45px",
        width: "auto",
        objectFit: "contain",
      
      }}
    />
  </div>

  <form onSubmit={handleSubmit} style={{ marginBottom: "50px" }}>
                   {currentPage.elements
    .filter(q => !(q.isHide ?? false))
    .map(renderQuestion)}

    <Footer
      currentQuestion={currentPage}
      currentQuestionIndex={pageIndex}
      survey={pages}
      handleNextClick={isLastPage ? onCompleteClick : onNextClick}
      handleBackClick={onBackClick}
      handleSubmitClick={onNextClick}
      isLastPage={pageIndex === pages.pages.length - 1}
      allowBack={pages.allowback ? parseInt(pages.allowback) : 0}
    />
  </form>
</div>

    );
  };
  const renderCompletionScreen = () => {
    return (
      <div>
        {/* <hr style={{ margin: 0 }}  /> */}
        <div
          className="completion-screen"
          style={{
            textAlign: "center",
            padding: "40px",

            //maxWidth: '600px',
            margin: "0 auto",
          }}
        >
          <h5>Thank You!</h5>
          <p>Your Feedback is valuable to us.</p>
          {/* Add any additional completion content here */}
        </div>
      </div>
    );
  };

  return (
    <div>
      {isComplete
        ? renderCompletionScreen()
        : pages.pages[pageIndex]?.elements &&
          renderPage(pages.pages[pageIndex], pageIndex)}
    </div>
  );
  // return <div>{pages.pages.map(renderPage)}</div>;
};

export default Questionnaire;
